import { render, staticRenderFns } from "./npl-zb.vue?vue&type=template&id=2f45513c&scoped=true"
import script from "./npl-zb.vue?vue&type=script&lang=js"
export * from "./npl-zb.vue?vue&type=script&lang=js"
import style0 from "./npl-zb.vue?vue&type=style&index=0&id=2f45513c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45513c",
  null
  
)

export default component.exports